import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from 'reactstrap';
import BookingInfo from './BookingInfo';
import BookingEvents from './BookingEvents';

import classnames from 'classnames';
import BookingMessages from './BookingMessages';
import { logAmplitudeEvent } from '../utilities';

const TABS = {
  INFO: 1,
  HISTORY: 2,
  MESSAGES: 3
};
const BookingInfoModal = ({ bookingId, isOpen, toggle, mpid }) => {
  const [selectedTab, setSelectedTab] = useState(TABS.INFO);

  useEffect(() => {
    if (isOpen) {
      logAmplitudeEvent(
        'Info_Icon_Pressed',
        { selectedTab: 'INFO', mpid: mpid },
        true
      );
    }
    setSelectedTab(TABS.INFO);
    // eslint-disable-next-line
  }, [bookingId, mpid]);

  return (
    <Modal size="lg" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Booking Details</ModalHeader>
      <ModalBody>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: selectedTab === TABS.INFO })}
              onClick={() => {
                setSelectedTab(TABS.INFO);
                logAmplitudeEvent(
                  'Info_Icon_Pressed',
                  { selectedTab: 'INFO', mpid: mpid },
                  true
                );
              }}
            >
              INFO
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: selectedTab === TABS.HISTORY })}
              onClick={() => {
                setSelectedTab(TABS.HISTORY);
                logAmplitudeEvent(
                  'Info_Icon_Pressed',
                  { selectedTab: 'HISTORY', mpid: mpid },
                  true
                );
              }}
            >
              HISTORY
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: selectedTab === TABS.MESSAGES })}
              onClick={() => {
                setSelectedTab(TABS.MESSAGES);
                logAmplitudeEvent(
                  'Info_Icon_Pressed',
                  { selectedTab: 'MESSAGES', mpid: mpid },
                  true
                );
              }}
            >
              MESSAGES
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={selectedTab}>
          <TabPane tabId={TABS.INFO}>
            <BookingInfo bookingId={bookingId} />
          </TabPane>
          <TabPane tabId={TABS.HISTORY}>
            <div style={{ marginTop: '0.5rem' }}>
              {selectedTab === TABS.HISTORY && (
                <BookingEvents bookingId={bookingId} />
              )}
            </div>
          </TabPane>
          <TabPane tabId={TABS.MESSAGES}>
            <div style={{ marginTop: '0.5rem' }}>
              {selectedTab === TABS.MESSAGES && (
                <BookingMessages bookingId={bookingId} />
              )}
            </div>
          </TabPane>
        </TabContent>
      </ModalBody>
    </Modal>
  );
};

BookingInfoModal.propTypes = {
  bookingId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  mpid: PropTypes.func.isRequired
};

export default BookingInfoModal;
